import Vue from 'vue'
import Router from 'vue-router'
import ProfilePage from '@/components/profile-page/profile-page.vue'
import TicketsAndBar from '@/components/tickets-and-bar/wrapper.vue'
import Loyalty from '@/components/loyalty/wrapper.vue'
import Login from '@/components/login/wrapper.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
        if (to.hash === '#connect-open-id') {
          position.offset = { y: 65 }
        }
        if (document.querySelector(to.hash)) {
          return position
        }
        return false
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Tickets & bar',
      component: TicketsAndBar
    },
    {
      path: '/profile',
      name: 'Profile',
      component: ProfilePage
    },
    {
      path: '/loyalty',
      name: 'Loyalty',
      component: Loyalty
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js